<template>
<!-- 视频管理 -->
  <div id="feedFlareManage">
    <div class="allMenuHead">
        <!-- v-if="$childMenu.indexOf('跳转配置') >= 0"  -->
      <div :class="step ? 'active' : ''" v-if="$childMenu.indexOf('跳转配置') >= 0" @click="toUrl('feedFlareList', 2)" class="d_i headTab p_r">跳转配置<div class="p_a"></div></div>
    </div>
    <div class="allHeaderRouter">
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
let Time
  export default {
    name: 'feedFlareManage',
    data () {
      return {
        step: true,
        isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin'),
        appowner: JSON.parse(window.sessionStorage.getItem('nowApp'))
      }
    },
    created () {
      Time = setInterval(p => {
        if (window.location.href.indexOf('feedFlareList') >= 0) {
          this.step = true
        }
      }, 100)
    },
    destroyed () {
      clearInterval(Time)
    },
    methods: {
      toUrl (url, num) {
        if (num === 1) {
          this.step = true
        } else {
          this.step = false
        }
        this.$router.push({
          name: url
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/feedFlareManage/feedFlareManage.vue